<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button> -->
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "STUDENT_GROUPING" | translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>

                <div style="text-align: center;font-size: 16px;font-weight: bold;" *ngIf="false">Show message here if
                    enrollment is finilizes</div>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <!-- <div class="card-header" id="headingOne" style="padding: 3px;">
                            <h5 class="mb-0"
                                style="text-align: center;font-weight:bold;text-align: center;font-weight: bold;">
                                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne" style="width: 100%;">
                                    {{"ADVANCED_SEARCH" | translate | titlecase }}
                                    <i class="fas fa-filter"></i>
                                </button>
                            </h5>
                        </div> -->

                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester" (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "STATUS" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="status">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}</option>
                                                <option *ngFor="let field of studentStatuses" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.sstatusNameAr :
                                                    field?.sstatusNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.status.touched && searchForm.controls.status.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "GENDER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="gender">
                                                <option value="ALL" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}</option>
                                                <option value="M">{{ "MALE" | translate | titlecase }}</option>
                                                <option value="F">{{ "FEMALE" | translate | titlecase }}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.gender.touched && searchForm.controls.gender.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "ASSIGNED_STATUS" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="statusAssign">
                                                <option value="ALL" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}</option>
                                                <option value="COMPLETED">{{ "COMPLETED" | translate | titlecase }}</option>
                                                <option value="PARTIAL">{{ "PARTIAL" | translate | titlecase }}</option>
                                                <option value="PENDING">{{ "PENDING" | translate | titlecase }}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.statusAssign.touched && searchForm.controls.statusAssign.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>
                                </form>
                                <hr />
                                <div class="row">
                                    <div class="col-md-4 form-group px-md-5 mb-5">
                                        <label class="font-bold"></label>
                                        <button type="button" class="btn btn-success" data-toggle="modal"
                                            data-target="#theoryGroupModal">
                                            <i class="fas fa-plus"></i> {{ "GROUP" | translate | titlecase }}</button>
                                    </div>
                                    <!-- <div class="col-md-2.5 form-group px-md-5 mb-5" >
                                        <button type="button" class="btn btn-success" data-toggle="modal"
                                        data-target="#clinicalGroupModal">
                                           <i class="fas fa-plus"></i> {{ "CLINICAL_GROUPING" | translate | titlecase }}</button>
                                    </div> -->
                                    <!-- <div class="col-md-2 form-group px-md-5 mb-5">
                                        <select class="form-control" class="btn btn-info">
                                            <option value="" [selected]="true">{{ "THEORY_GROUPING" | translate | titlecase
                                                }}
                                            </option>
                                            <option *ngFor="let field of searchByFields" [ngValue]="field.key">
                                                {{field.value}}</option>
                                        </select>
                                    </div> -->
                                    <!-- <div class="col-md-2 form-group px-md-5 mb-5">
                                        <select class="form-control" class="btn btn-info">
                                            <option value="" [selected]="true">{{ "CLINICAL_GROUPING" | translate | titlecase
                                                }}
                                            </option>
                                            <option *ngFor="let field of searchByFields" [ngValue]="field.key">
                                                {{field.value}}</option>
                                        </select>
                                    </div> clinicalGroupModal-->
                                    <div class="col-md-4 form-group px-md-5 mb-5"
                                        *ngIf="!repeaterPage && students.length >= 1">
                                        <button type="button" class="btn btn-warning" data-toggle="modal"
                                            data-target="#assignGroupProccessedModal">
                                            {{ "ASSIGN_GROUP" | translate | titlecase }}</button>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <div style="height: 500px; overflow-y: scroll;">
                        <table *ngIf="students.length >= 1" class="table-striped" data-sticky-header="true"
                            id="datatable">
                            <thead style="    position: sticky; top: 0; background: white;">
                            <tr>
                                <th  style="text-align:center; background: white;"><input type="checkbox" name="select_all" value="1" class="select-all" ></th>
                                <th>{{ "MAT_NO" | translate | titlecase }}</th>
                                <th>{{ "FULL_NAME_ARABIC" | translate | titlecase }}</th>
                                <th>{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</th>
                                <th>{{ "STUDENT_STATUS" | translate | titlecase }}</th>
                                <th>{{ "GENDER" | translate | titlecase }}</th>
                                <th>{{ "ASSIGN_GROUP_STATUS" | translate | titlecase }}</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <!-- <th class="border-0 font-14 px-2 text-grey">{{ "EDIT" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "EDIT" | translate | titlecase
                                    }}</th> -->
                                <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of students let i = index">
                                <td></td>
                                <td>{{res?.studentid}}</td>
                                <td>{{res?.fullNameAr}}</td>
                                <td>{{res?.fullNameEn}}</td>
                                <td>{{
                                    (globals.lang == 'ar')? res?.studentStatusAr :
                                    res?.studentStatusEn
                                    }}
                                </td>
                                <td>
                                    {{ res?.gender == "M"? ("MALE" | translate | titlecase) :
                                    ("FEMALE" | translate |
                                    titlecase) }}
                                </td>
                                
                                <td>{{res?.groupAssignmentStatus}}</td>
                                <td class="text-bold text-warning">
                                    <!-- <a class="btn btn-sm btn-link text-warning" routerLink="/enrolment/update-course"
                                        [queryParams]="{studentId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a> routerLink="#deleteModal" -->
                                    <a class="btn btn-sm btn-link text-warning"
                                        (click)="assignGroupRepeater(res.studentid)"><i class="fas fa-book"></i></a>
                                </td>
                                <td class="text-bold text-warning">
                                    <!-- <a class="btn btn-sm btn-link text-warning" routerLink="/enrolment/update-course"
                                        [queryParams]="{studentId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a> routerLink="#deleteModal" -->
                                    <a class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#studentInfoModal"><i class="fas fa-user"></i></a>
                                </td>
                                <!-- <td class="text-bold text-warning" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">
                                    <button class="btn btn-sm btn-link text-warning" (click)="editCourse(res?.id)"><i
                                            class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</button>
                                </td> -->
                                <td class="text-bold text-success" *ngIf="globals.checkUserHasPermission('APPLICATION_STATUS - DELETE')">
                                    <button class="btn btn-sm btn-link text-success" data-toggle="modal" 
                                        title="{{ 'SEMESTER_STUDENT_STATUS_UPDATE' | translate | titlecase }}"
                                        data-target="#theoryGroupStatusModal" (click)="getCurrentGroupStatus(res?.studentid)">
                                        <i class="fas fa-book"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="theoryGroupModal" tabindex="-1" aria-labelledby="theoryGroupModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="theoryGroupModalContainer">
        <form class="modal-content col-md-12" #theoryGroupFormTag="ngForm" [formGroup]="theoryGroupForm"
            (submit)="theoryGroupFormSubmit(theoryGroupFormTag.value)">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "ADD_GROUP" | translate | titlecase}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">
                    <div class="col-md-6 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ARABIC_NAME" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="arabicName">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="theoryGroupForm.controls.arabicName.touched && theoryGroupForm.controls.arabicName.invalid && theoryGroupForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-6 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ENGLISH_NAME" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="englishName">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="theoryGroupForm.controls.englishName.touched && theoryGroupForm.controls.englishName.invalid && theoryGroupForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-6 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "GROUP_CODE" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="groupCode">

                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="theoryGroupForm.controls.groupCode.touched && theoryGroupForm.controls.groupCode.invalid && theoryGroupForm.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-6 form-group px-md-5 mb-4">
                        <label class="font-bold"> {{ "GROUP_TYPE" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="type">
                            <option [ngValue]="">{{ "SELECT" | translate | titlecase }}</option>
                            <option value="THEO">{{ "THEORY_GROUP" | translate | titlecase }}</option>
                            <option value="CLNC">{{ "CLINICAL_GROUP" | translate | titlecase }}</option>
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="theoryGroupForm.controls.type.touched && theoryGroupForm.controls.type.invalid && theoryGroupForm.dirty">
                            {{"PLEASE_SELECT" | translate | titlecase}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-EditAcceptCand2" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>

<div class="modal fade" id="assignGroupProccessedModal" tabindex="-1" aria-labelledby="assignGroupProccessedModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" id="assignGroupProccessedModalContainer">
        <form class="modal-content col-md-12" #assignGroupProccessedFormTag="ngForm"
            [formGroup]="assignGroupProccessedForm"
            (submit)="assignGroupProccessedFormSubmit(assignGroupProccessedFormTag.value)">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "ASSIGN_GROUP" | translate | titlecase}}</h5>
                
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row col-md-4 form-group  mb-4">
                    <label class="font-bold"> {{ "TYPE_ASSIGN" | translate | titlecase }}</label>
                    <select class="form-control custom-select" formControlName="type">
                        <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                        
                        <option value="all">{{ "ALL" | translate | titlecase }}</option>
                        <option value="theory">{{ "THEORY_GROUPING" | translate | titlecase }}</option>
                        <option value="clincal">{{ "CLINICAL_GROUPING" | translate | titlecase }}</option>
                    </select>
                    <div class="alert alert-danger py-1 mt-1"
                    *ngIf="assignGroupProccessedForm.controls.type.touched && assignGroupProccessedForm.controls.type.invalid && assignGroupProccessedForm.dirty">
                        <!-- *ngIf="assignGroupProccessedFormIsTouched(res.thGroupControllerName) && assignGroupProccessedFormIsInvalid(res.thGroupControllerName) && assignGroupProccessedForm.dirty"> -->
                        {{"PLEASE_SELECT" | translate | titlecase}}
                    </div> 
                </div>
                <div class="row" *ngFor="let res of batchCourses;let i = index" [attr.data-index]="i">
                    <div class="col-md-4 form-group  mb-4">
                        <label class="font-bold">{{ "SUBJECT_NAME" | translate | titlecase }}</label>
                        <input type="text" class="form-control" value="{{res.subjectNameEn}} - {{res.subjectCode}}"
                            readonly>
                    </div>
                    <div class="col-md-4 form-group  mb-4">
                        <label class="font-bold"> {{ "THEORY_GROUP" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="{{res.thGroupControllerName}}">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <option value={{thGroup?.id}} *ngFor="let thGroup of theoryFilteredGroups[i]">{{thGroup?.egroupNameEn}}
                                ({{thGroup.egroupCode}}) </option>
                            <!-- <option value="spring">{{ "SPRING" | translate | titlecase }}</option>
                            <option value="fall">{{ "FALL" | translate | titlecase }}</option> -->
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="assignGroupProccessedFormIsTouched(res.thGroupControllerName) && assignGroupProccessedFormIsInvalid(res.thGroupControllerName) && assignGroupProccessedForm.dirty">
                            {{"PLEASE_SELECT" | translate | titlecase}}
                        </div>
                    </div>
                    <div class="col-md-4 form-group  mb-4">
                        <label class="font-bold"> {{ "CLINICAL_GROUP" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="{{res.clGroupControllerName}}">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <!-- <option value="spring">{{ "SPRING" | translate | titlecase }}</option>
                            <option value="fall">{{ "FALL" | translate | titlecase }}</option> -->
                            <option value={{clGroup?.id}} *ngFor="let clGroup of clinicalFilteredGroups[i]">
                                {{clGroup?.egroupNameEn}} ({{clGroup.egroupCode}})</option>
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="assignGroupProccessedFormIsTouched(res.clGroupControllerName) && assignGroupProccessedFormIsInvalid(res.clGroupControllerName) && assignGroupProccessedForm.dirty">
                            {{"PLEASE_SELECT" | translate | titlecase}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-EditAcceptCand1" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "ASSIGN" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>

<div class="modal fade" id="studentInfoModal" tabindex="-1" aria-labelledby="studentInfoModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-info-circle"></i>
                </div>
                <div class="p-2"><b>{{ "NOT_AVAILABLE" | translate | titlecase }}</b> </div>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="assignGroupRepeaterModal" tabindex="-1" aria-labelledby="assignGroupRepeaterModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" id="assignGroupRepeaterModalContainer">
        <form class="modal-content col-md-12" #assignGroupRepeaterFormTag="ngForm" [formGroup]="assignGroupRepeaterForm"
            (submit)="assignGroupRepeaterModalFormSubmit(assignGroupRepeaterFormTag.value)">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "ASSIGN_GROUP" | translate | titlecase}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row" *ngFor="let res of studentCourses;let i = index" [attr.data-index]="i">
                    <div class="col-md-3 form-group  mb-4">
                        <label class="font-bold">{{ "SUBJECT_NAME" | translate | titlecase }}</label>
                        <input type="text" class="form-control" value="{{res.subjectNameEn}} - {{res.subjectCode}}"
                            readonly>
                    </div>
                    <div class="col-md-3 form-group  mb-4" *ngIf="repeaterPage">
                        <label class="font-bold"> {{ "STATUS" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="{{res.subjectStatusControllerName}}"
                            [attr.disabled]="res.disableStatus" *ngIf="res.disableStatus">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let field of subjectStates" [ngValue]="field.id">
                                {{
                                (globals.lang == 'ar')? field?.ssstatusNameAr : field?.ssstatusNameEn
                                }}
                            </option>
                        </select>
                        <select class="form-control custom-select" formControlName="{{res.subjectStatusControllerName}}"
                            *ngIf="!res.disableStatus">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let field of subjectStates" [ngValue]="field.id">
                                {{
                                (globals.lang == 'ar')? field?.ssstatusNameAr : field?.ssstatusNameEn
                                }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3 form-group  mb-4">
                        <label class="font-bold"> {{ "THEORY_GROUP" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="{{res.thGroupControllerName}}">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <option value={{thGroup?.id}} *ngFor="let thGroup of theoryFilteredGroups[i]">
                                {{thGroup?.egroupNameEn}}
                                ({{thGroup.egroupCode}}) </option>
                        </select>
                        <div class="alert alert-danger py-1 mt-1"
                            *ngIf="assignGroupRepeaterFormIsTouched(res.thGroupControllerName) && assignGroupRepeaterFormIsInvalid(res.thGroupControllerName) && assignGroupRepeaterForm.dirty && !repeaterPage">
                            {{"PLEASE_SELECT" | translate | titlecase}}
                        </div>
                    </div>
                    <div class="col-md-3 form-group  mb-4">
                        <label class="font-bold"> {{ "CLINICAL_GROUP" | translate | titlecase }}</label>
                        <select class="form-control custom-select" formControlName="{{res.clGroupControllerName}}">
                            <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                            <option value={{clGroup?.id}} *ngFor="let clGroup of clinicalFilteredGroups[i]">
                                {{clGroup?.egroupNameEn}} ({{clGroup.egroupCode}}) </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-EditAcceptCand" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "ASSIGN" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>
        
        <div class="modal fade" id="theoryGroupStatusModal" tabindex="-1" aria-labelledby="theoryGroupStatusLabel"
            aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form class="modal-content col-md-12" [formGroup]="theoryGroupStatus"
                        (submit)="theoryGroupStatusTagSubmit()">
                        <div class="modal-header">
                            <h5 class="modal-title" id="DisableServiceDataLabel">{{ "SEMESTER_STUDENT_STATUS_UPDATE" | translate
                                | titlecase}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body px-md-12">
                            <div class="row">
                                <div class="col-md-6 form-group px-md-8 mb-4">
                                    <label class="font-bold"> {{ "STATUS" | translate | titlecase }}</label>
                                    <select class="form-control custom-select" formControlName="status">>
                                        <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                        <option value={{sts?.id}} *ngFor="let sts of studentGroupStatus">
                                            {{
                                            (globals.lang == 'ar')? sts?.sstatusNameAr : sts.sstatusNameEn
                                            }}
                                        </option>
                                    </select>
                                    <!-- <div class="alert alert-danger py-1 mt-1">
                                            {{"PLEASE_SELECT" | translate | titlecase}}
                                        </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" id="close-EditAcceptCand3" class="btn btn-outline-secondary"
                                data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                            <!-- <a type="button" class="btn btn-link text-success" (click)="theoryGroupStatusTagSubmit()">{{ "SAVE"
                                        | translate | titlecase }}</a> -->
        
                            <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>